
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M19.75 4H4.75C4.55109 4 4.36032 4.07902 4.21967 4.21967C4.07902 4.36032 4 4.55109 4 4.75V7C4.00004 7.1989 4.07909 7.38963 4.21975 7.53025L10 13.3105V21.25C10 21.3893 10.0388 21.5258 10.112 21.6443C10.1852 21.7628 10.29 21.8585 10.4146 21.9208C10.5392 21.9831 10.6786 22.0095 10.8174 21.997C10.9561 21.9845 11.0886 21.9336 11.2 21.85L14.2 19.6C14.2932 19.5301 14.3688 19.4396 14.4208 19.3354C14.4729 19.2313 14.5 19.1164 14.5 19V13.3105L20.2803 7.53025C20.4209 7.38963 20.5 7.1989 20.5 7V4.75C20.5 4.55109 20.421 4.36032 20.2803 4.21967C20.1397 4.07902 19.9489 4 19.75 4Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowfilterFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
